import React, { useState, useEffect } from 'react';
import Button from './smallerComponent/Button';
import Description from './smallerComponent/Description';
import Card from './smallerComponent/Card';
import Brand from '../images/icon-brand-recognition.svg';
import Records from '../images/icon-detailed-records.svg';
import Customize from '../images/icon-fully-customizable.svg';
import axios from 'axios';
import {CopyToClipboard} from 'react-copy-to-clipboard';


export default function Second(){
    
    const [url, setUrl] = useState("");
    const [shorturl, setShorturl] = useState([]);
    const [list, setList] = useState([]);
    const [ecolor, setEcolor] = useState("none");
    const [copy, setCopy] = useState("Copy");
    const [btnn, setBtn] = useState("btn");
    const [iscopy, setIscopy] = useState(false);

    console.log(list)
    
    const api = 'https://api.shrtco.de/v2/shorten?url=' + url;

    useEffect(()=> {
        axios.post(api)
        .then(response => setShorturl(response.data.result.short_link))
      },[api])

    const show = (e) => {
        e.preventDefault();
        const sLink = {url, shorturl};
        if(url){
            setList((link)=> [...link, sLink])
            setUrl("")
            setShorturl("")
        }
        else if(!url){
            setEcolor("red")
            
        }
    }
  
     const onCopyText = () => {
       if(iscopy == false){
        setIscopy(true)
        setBtn("btn2")
        setCopy("Copied!")
       }
       else{
        setIscopy(false)
        setBtn("btn")
        setCopy("Copy")
       }
      };

    return(
        <div className="second">
            <form className="search"  onSubmit={show}>
               <Button id={ecolor} className="input" type="text" value={url} placeholder="Shorten a link here..." onChange={(e) => setUrl(e.target.value)}/>
               <Button className="shorten" id="btn"  type="submit" value="Shorten It"/>
            </form>
               {
                   list.map((link)=>
                   <div className="list">
                      <div><span style={{color:"black", fontSize: "15px"}}>{link.url}</span></div>
                      <div className="side">
                      <div><span className="shortl"style={{color:"hsl(180, 66%, 49%)", fontSize: "15px"}}>{link.shorturl}</span></div>
                      <div> <CopyToClipboard text={link.shorturl} onCopy={link.shorturl} >
                      <span><button onClick={onCopyText} className={btnn}>{copy}</button></span>
                      </CopyToClipboard></div>
                      </div>
                   </div>
                   )
               }
             <Description id="aHead" header="Advanced Statistics" paragraph="Track how your links are performing accross the web with our advanced statistics dashboard"/>
             <div className="bottom">
             <div>
                <Card className="cardImage fCard" id="img"  header="Brand Recognition" paragraph="lorem Ipsum lorem ips Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci eaque nemo ipsum corrupti, expedita exercitationem dolores perferendis veritatis enim animi. Adipisci, sint? Laboriosam beatae pariatur fuga, quasi saepe rem at!" src={Brand} alt="recognition"/>
                </div>
                <div className="line" id="line"></div>
                <div>
                <Card className="cardImage" id="marg"  header="Detailed Records" src={Records} alt="records"paragraph="lorem Ipsum lorem ips Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci eaque nemo ipsum corrupti, expedita exercitationem dolores perferendis veritatis enim animi. Adipisci, sint? Laboriosam beatae pariatur fuga, quasi saepe rem at!"/>
                </div>
                <div className="line" id="line2"></div>
                <div>
                <Card className="cardImage" id="marg2" header="Fully Customizable" src={Customize} alt="recognition" paragraph="lorem Ipsum lorem ips Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci eaque nemo ipsum corrupti, expedita exercitationem dolores perferendis veritatis enim animi. Adipisci, sint? Laboriosam beatae pariatur fuga, quasi saepe rem at!"/>
                </div>
             </div>
           
        </div>
    )
}